module.exports = __webpack_public_path__ + "static/img/LH.48333113.png";